module.exports = __webpack_public_path__ + "static/img/flat.3149777.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trade/img/flat.png
// module id = ADUp
// module chunks = 1